module.exports = __webpack_public_path__ + "static/social-latest-posts-d5087f6a91a089b3088510a1e39b11f4.png";